import { useCallback, useState } from "react";
//#region src/lib/useControllable.ts
/** A value that is controlled when `controlled` isn't undefined, and local state otherwise. */
function useControllable(controlled, initial, onChange) {
	const [local, setLocal] = useState(initial);
	return [controlled === void 0 ? local : controlled, useCallback((next) => {
		if (controlled === void 0) setLocal(next);
		onChange?.(next);
	}, [controlled, onChange])];
}
//#endregion
export { useControllable };

//# sourceMappingURL=useControllable.js.map